export default function ($scope, $sce, $timeout, $anchorScroll, $filter, Api, Restangular, FlashService, user, states, subscriptions, games, purchase, active_licences) {

    $scope.licences_pro  = [];
    $scope.licences_vr = [];
    $scope.licences_gold = [];
    $scope.active_licences = active_licences;

    $scope.has_company = GetData().currentUser.company;
    $scope.user = user;
    $scope.states = states;
    $scope.iban = Api.IBAN;

    $scope.image_path = Api.IMAGES + 'uploads/products/';

    if(purchase.id){
        $scope.purchase = purchase;
        $scope.show_only = purchase.product.type
    }
    else
        $scope.show_only = purchase;

    $scope.subscriptions = subscriptions;
    $scope.games = games;

    $scope.active_licences.forEach(function(licence, index){
        if(licence.type.code == 'vr'){
            $scope.licences_vr.push(licence);
        }
        if(licence.type.code == 'pro'){
            $scope.licences_pro.push(licence);
        }
        if(licence.type.code == 'gold' || licence.type.code == 'specialist'){
            $scope.licences_gold.push(licence);
        }
    });

    $scope.gotoAnchor = function(x) {
        $timeout(function(){
            $anchorScroll($scope.show_only);
        }, 1);
    }

    $scope.types = {};

    if($scope.licences_pro.length || $scope.licences_gold.length){
        $scope.types['subscription'] =
            {
                name : 'SUBSCRIPTIONS'
            }
    }

    if($scope.licences_vr.length){
        $scope.types['game'] =
            {
                name : 'GAMES VR'
            }
    }

    $scope.translate = function(text){
        return $filter('translate')(text);
    }

};


/** WEBPACK FOOTER **
 ** ./js/theme/purchases/controller.js
 **/